import { useEffect, useState } from "react";
import { fetchPublicDbClasses } from "@/lib/dbClasses";
import type { ClassItem } from "@/data/classes";
import { supabase } from "@/integrations/supabase/client";

export function useDbClasses() {
  const [items, setItems] = useState<ClassItem[]>([]);
  useEffect(() => {
    let mounted = true;
    fetchPublicDbClasses().then((rows) => { if (mounted) setItems(rows); });
    const ch = supabase.channel("public-classes")
      .on("postgres_changes", { event: "*", schema: "public", table: "classes" }, () => {
        fetchPublicDbClasses().then((rows) => { if (mounted) setItems(rows); });
      }).subscribe();
    return () => { mounted = false; supabase.removeChannel(ch); };
  }, []);
  return items;
}
